exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newspaper[data-v-2a3909ac]{-webkit-column-gap:20px;column-gap:20px;-webkit-column-count:2;column-count:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a3909ac","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/tickets/TicketInfo.vue
// module id = 8uyC
// module chunks = 0